import { useEffect, useState, useRef } from 'react';
import { formatDuration, getRemainingMs } from '@app/shared/utils/countdown';

export const useLiveCountdown = (lastAt: number, intervalMs: number) => {
  const calcMsLeft = () => getRemainingMs(lastAt, intervalMs);

  const [msLeft, setMsLeft] = useState(calcMsLeft);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    setMsLeft(calcMsLeft());
  }, [lastAt, intervalMs]);

  useEffect(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }

    const currentMsLeft = getRemainingMs(lastAt, intervalMs);
    if (currentMsLeft <= 0) {
      setMsLeft(0);
      return;
    }

    setMsLeft(currentMsLeft);

    intervalRef.current = setInterval(() => {
      const newMsLeft = getRemainingMs(lastAt, intervalMs);
      setMsLeft(newMsLeft);

      if (newMsLeft <= 0 && intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    }, 1000);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [lastAt, intervalMs]);

  return {
    msLeft,
    formattedLeft: formatDuration(msLeft),
    isExpired: msLeft <= 0,
  };
};
